import React from 'react';
import { Checkbox, Typography, Box } from '@mui/material';
import { User } from '../../services/api';

interface UserRolesProps {
  user: User;
  availableRoles: string[];
  users: User[];
  onRoleChange: (username: string, role: string, checked: boolean) => void;
}

const UserRoles: React.FC<UserRolesProps> = ({ user, availableRoles, users, onRoleChange }) => {
  return (
    <>
      {availableRoles.map(role => (
        <Box key={role} display="flex" alignItems="center" my={1}>
          <Checkbox
            checked={user.roles.includes(role)}
            onChange={e => onRoleChange(user.username, role, e.target.checked)}
            disabled={
              // Prevent removing the last system admin
              role === 'SystemAdministrators' &&
              user.roles.includes('SystemAdministrators') &&
              users.filter(u => u.roles.includes('SystemAdministrators')).length <= 1
            }
          />
          <Typography variant="body2">{role}</Typography>
        </Box>
      ))}
    </>
  );
};

export default UserRoles;
